import { render, staticRenderFns } from "./thumbnails-image-grid.component.vue?vue&type=template&id=6f6fd474&scoped=true"
import script from "./thumbnails-image-grid.component.vue?vue&type=script&lang=js"
export * from "./thumbnails-image-grid.component.vue?vue&type=script&lang=js"
import style0 from "./thumbnails-image-grid.component.vue?vue&type=style&index=0&id=6f6fd474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6fd474",
  null
  
)

export default component.exports